import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UnacknowledgedChangesTableDefinitionZod } from '../tables';

type Arguments = {
    id?: string | null;
    position?: number;
};
export const schemaLoanRequestResolver_GetUnacknowledgedChanges = z.array(UnacknowledgedChangesTableDefinitionZod);

export type SchemaLoanRequestResolver_GetUnacknowledgedChanges = z.infer<
    typeof schemaLoanRequestResolver_GetUnacknowledgedChanges
>;

export type LoanRequestResolver_GetUnacknowledgedChanges = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetUnacknowledgedChanges
>;
